import { NavLink } from 'react-router-dom';
import Icon from './Icon';

const items = [
  { to: '/', label: 'Home', icon: 'home', end: true },
  { to: '/academy', label: 'Academy', icon: 'school' },
  { to: '/pricing', label: 'Pricing', icon: 'payments' },
  { to: '/contact', label: 'Contact', icon: 'mail' },
];

export default function MobileBottomNav() {
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-[60] bg-surface-container-low/95 backdrop-blur-md border-t border-outline-variant flex justify-around items-center py-2 px-2 shadow-lg pb-[max(0.5rem,env(safe-area-inset-bottom))]"
      aria-label="Mobile bottom navigation"
    >
      {items.map(({ to, label, icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `flex flex-col items-center gap-0.5 text-[10px] min-w-[4rem] py-1 ${
              isActive ? 'text-primary font-bold' : 'text-on-surface-variant'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon name={icon} className="text-[22px]" filled={isActive} />
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
